import img from "../Assets/images/worker-image.png";

const workerData = [
  {
    id: 1,
    name: "John Doe",
    role: "Plumber",
    image: img,
    status: "completed",
    time: "03-05-2025 10.00-22.00",
    place: "Ettumanoor, Kottayam",
    amount: "$ 30000",
  },
  {
    id: 2,
    name: "GEORGE",
    role: "Electrician",
    image: img,
    status: "pending",

    time: "03-05-2025 10.00-22.00",
    place: "Ettumanoor, Kottayam",
    amount: "$ 30000",
  },
  {
    id: 3,
    name: "Don",
    role: "Plumber",
   image: img,
    status: "completed",
    time: "03-05-2025 10.00-22.00",
    place: "Ettumanoor, Kottayam",
    amount: "$ 30000",
  },
  {
    id: 4,
    name: "john",
    role: "Plumber",
    image: img,
    status: "completed",
    time: "03-05-2025 10.00-22.00",
    place: "Ettumanoor, Kottayam",
    amount: "$ 30000",
  },
  {
    id: 5,
    name: "joy",
    role: "Electrician",
   image: img,
    status: "completed",
    time: "03-05-2025 10.00-22.00",
    place: "Ettumanoor, Kottayam",
    amount: "$ 30000",
  },
  {
    id: 6,
    name: "joel",
    role: "Plumber",
    image: img,
    status: "completed",
    time: "03-05-2025 10.00-22.00",
    place: "Ettumanoor, Kottayam",
    amount: "$ 30000",
  },
];

export default workerData;
